import { handleErrorSentry } from "../utils/constants/Error"
import { axiosInstance } from "./Axios"


export const sendEmail = async (visitId) => {
    await axiosInstance.post(`/api/v1/visits/${visitId}/send_email`).catch(error => {
        handleErrorSentry(error, "tryCatch")
    })
}